/*
 * Custom Wistia Styles
 */

const flPage = document.querySelector("html");

window._wq = window._wq || [];
_wq.push({
  id: "_all",
  options: {
    playButton: true,
    popoverPreventScroll: true,
    playerColor: "0072ea", // BST Blue
  },
  onReady: function (video) {
    video.bind("popovershow", function () {
      flPage.classList.add("html-wistia-open"); // Prevent user from scrolling when pop-up is shown
    });
    video.bind("popoverhide", function () {
      flPage.classList.remove("html-wistia-open"); // Enable user from scrolling after pop-up is closed
    });
  },
});
